import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import TeachingsSection from './components/TeachingsSection';
import BhajansSection from './components/BhajansSection';
import AshramSection from './components/AshramSection';
import GallerySection from './components/GallerySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white">
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <TeachingsSection />
          <BhajansSection />
          <AshramSection />
          <GallerySection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
